<template>
    <section class="section my-6">
        <div class="container is-flex">

            <div class="card" id="image">
                <div class="card-image">
                    <figure class="image">
                        <img style="border-radius: .5rem" :src="configs.hero.background_url">
                    </figure>
                </div>
            </div>

            <div class="card pa-6" id="how-works-content" :style="computedStyle">
                <div class="card-content">
                    <h2 class="cp-title-2 mb-2" :style="computedFont"
                    >{{ configs.hero.title }}</h2>

                    <div class="cp-line-lh" style="background-color: white">
                        <div :style="blurPrimaryColor" class="cp-line-lh"></div>
                    </div>

                    <p class="my-6">{{ configs.features.description }}</p>

                    <section class="mt-6" v-for="(feature, index) in configs.features.items" :key="index">
                        <div v-if="!hideCashback || index != cashbackTradeIndex" class="is-flex mb-7 mobile-align">
                            <div class="cp-circle" style="background-color: white">
                                <span class="cp-circle is-flex" :style="blurPrimaryColor">
                                    <p class="is-size-2 has-text-weight-bold">{{`0${index + 1 }`}}</p>
                                </span>
                            </div>

                            <div class="ml-6 is-hidden-mobile">
                                <div class="mt-4">
                                    <p class="cp-title-4" :style="computedFont">{{ feature.title }}</p>
                                    <p>{{ feature.description }}</p>
                                </div>
                            </div>
                            <!-- Show only mobile -->
                            <div class="is-hidden-tablet">
                                <div class="is-hidden-tablet">
                                    <p class="cp-title-4" :style="computedFont">{{ feature.title }}</p>
                                    <p>{{ feature.description }}</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
        cashbackTradeIndex: 2,
    }),
    props: {
        configs: {
            required: true,
            type: Object,
        },
    },
    computed: {
        ...mapGetters({
            styles: 'company/landing_page_colors',
            hideCashback: 'company/hide_cashback',
        }),
        computedStyle() {
            return {
                'color': this.styles.card_font_color ,
                'background-color': this.styles.card_background_color,
            }
        },
        computedFont() {
            return {
            'color': this.styles.card_font_color,
            }
        },
        blurPrimaryColor() {
            const alpha = 0.5
            const [r, g, b] = this.styles.card_background_color
                .match(/\w\w/g)
                .map(x => parseInt(x, 16))

            return {
                'background-color': `rgba(${r},${g},${b},${alpha})`,
            }
        }
    },
}
</script>


<style scoped>
.card{
    max-width: 39.125rem;
}
#image{
    max-width: 32.8125rem;
    max-height: 39.125rem;
}
#how-works-content {
    margin-top: 7.1875rem;
    margin-left: -3.375rem;
}

@media screen and (max-width: 768px) {
   .container{
       display: flex;
       flex-direction: column-reverse;
       margin-bottom: 90% !important;
   }
   #image{
       position:absolute;
        z-index: 2;
        background: transparent;
        min-height: 80%;
        min-width: 80%;
        top: 135%;
        left: 50%;
        margin-top: 2rem;
        transform: translate(-50%, -50%);
    }
    #how-works-content {
       margin: 0 auto;
       position: relative;
       z-index: 1;
    }
    .card-content {
        display: flex;
        flex-direction: column;
        
        justify-content: center;
        align-items: center;
        text-align: center;

        padding: 0;
        padding-bottom: .5rem;
    }
    .mobile-align{
        display: flex;

        flex-direction: column;
        justify-content: center;
        align-items: center;
        
        margin-bottom: 0.825rem !important;
    }
}
</style>